<template>
  <div>
    <!-- Header 区域 -->
    <van-nav-bar title="我要反馈" left-arrow @click-left="$router.back()" fixed>
    </van-nav-bar>
    <div class="layout-container">
      <!-- 反馈内容 -->
      <div class="cmt-box">
        <van-field
          v-model.trim="commentText"
          rows="7"
          autosize
          type="textarea"
          maxlength="200"
          placeholder="请输入反馈内容"
          show-word-limit
        />
      </div>
      <!-- 提交按钮 -->
      <van-button
        type="primary"
        size="large"
        round
        :disabled="commentText.length === 0"
        @click="sendCommentFn"
        >提交</van-button
      >
    </div>
  </div>
</template>

<script>
import { insertArticleAPI, updateArticleAPI } from '@/api'
import { Notify } from 'vant'
export default {
  data() {
    return {
      item: null,
      commentText: '' // 反馈内容
    }
  },
  created() {
    // console.log(this.$route.params.item)
    // 接收其他页面传参
    this.item = this.$route.params.item
    if (!this.item) {
      // 如果没有传参，则说明是新增反馈
      this.commentText = ''
    } else {
      // 如果不为空，则把反馈内容填充到文本框中供用户修改
      this.commentText = this.item.noticeContent
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.goBack)
  },
  mounted() {
    window.addEventListener('popstate', () => {
      this.goBack();
    })
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/comment_list' })
    },
    // 提交按钮 - 点击事件
    async sendCommentFn() {
      this.$toast('此功能暂未开放')
      // console.log(this.commentText)
      // let res = null
      // if (!this.item) {
      //   // 如果item为空，即不是修改，是新增
      //   res = await insertArticleAPI({
      //     noticeTitle: this.commentText.slice(0, 20), // 截取内容的前20个字符作为标题
      //     noticeType: 5,
      //     noticeContent: this.commentText
      //   })
      // } else {
      //   // 否则，更新反馈
      //   res = await updateArticleAPI({
      //     noticeId: this.item.noticeId,
      //     noticeTitle: this.commentText.slice(0, 20), // 截取内容的前20个字符作为标题
      //     noticeContent: this.commentText
      //   })
      // }
      // console.log(res)
      // if (res.data.code !== 200) {
      //   Notify({ type: 'danger', message: res.data.msg })
      // } else {
      //   Notify({ type: 'success', message: '管理员已收到您的反馈！' })
      //   this.$router.replace('/comment_list')
      // }
    }
  }
}
</script>
<style lang="less" scoped>
.layout-container {
  margin: 60px 10px 20px;
}
.cmt-box {
  .van-field {
    border-radius: 8px;
  }
}
.van-button {
  margin-top: 15px;
}
</style>
